import { observable } from "mobx";

/**
 * ScreenStore
 *
 * @author nicolacastellani@vas.it
 * @description this is a substore to handle screen related behaviours
 */
export class Screen {
  @observable isMobile: boolean;
  constructor(isMobile: boolean) {
    this.isMobile = isMobile;
  }
}
